<template>
  <div class="this-box">
    <!-- 头部部分 -->
    <div class="head-bg">
      <div @click="setConterShow = true" class="right-set-ico"></div>
      <div class="center-cont">
        <div class="pic-head">
          <div
            v-if="userInfo.headIcon != ''"
            class="left-head-ico"
            :style="{
              backgroundImage: 'url(' + userInfo.headIcon + ')',
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
            }"
          ></div>

          <div
            v-else
            class="left-head-ico"
            :style="{
              backgroundImage: 'url(' + defaultHead + ')',
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
            }"
          ></div>
        </div>
        <div class="right">
          <div class="user-name">{{ name }}</div>
          <div class="role" @click="roleTransformShow = true">
            <div class="role-name">摄影师管家</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 订单部分 -->
    <div class="between">
      <div class="head-cont">
        <div class="left">我的订单</div>
        <div class="right">
          <router-link to="/Store/Order?orderStatus="
            >查看全部
            <van-icon name="arrow" />
          </router-link>
        </div>
      </div>
      <div class="option">
        <router-link to="/Grapher/Order?orderStatus=2" class="item">
          <div class="bg ico1"></div>
          <div class="titleA">待预约</div>
          <div class="tips"></div>
        </router-link>

        <router-link to="/Grapher/Order?orderStatus=5" class="item">
          <div class="bg ico2"></div>
          <div class="titleA">待审核</div>
        </router-link>

        <router-link to="/Grapher/Order?orderStatus=8" class="item">
          <div class="bg ico3"></div>
          <div class="titleA">打回</div>
        </router-link>

        <router-link to="/Grapher/Order?orderStatus=9" class="item">
          <div class="bg ico4"></div>
          <div class="titleA">已完成</div>
        </router-link>
      </div>
    </div>

    <!-- 视频教程 -->
    <!-- <div class="video-box">
      <div class="bottom-box">
        <div class="item bg3">
          <router-link to="/Course">
            <div class="content">
              <div class="title">开店教程<van-icon name="arrow" /></div>
            </div>
          </router-link>
        </div>

        <div class="item bg4">
          <div class="content" @click="goWatchVideo('Photographer')">
            <div class="title">教程视频<van-icon name="arrow" /></div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- 中部列表选项 -->
    <div class="between">
      <div class="head-cont">
        <div class="left">更多功能</div>
      </div>
      <div class="option">
        <div to="/Store/Grapher" @click="roleTransformShow = true" class="item">
          <div class="menu menu5"></div>
          <div class="titleA">身份互换</div>
        </div>

        <router-link to="/Grapher/ShootCitys" class="item">
          <div class="menu menu7"></div>
          <div class="titleA">约拍城市</div>
        </router-link>

        <router-link to="/User/UserInfo" class="item">
          <div class="menu menu8"></div>
          <div class="titleA">用户信息</div>
        </router-link>

        <router-link to="/User/BindWechat" class="item">
          <div class="menu menu6"></div>
          <div class="titleA">绑定微信</div>
        </router-link>

        <router-link to="/Store/HkHelp" class="item" v-if="isShowHkHelpButton">
          <div class="menu menu9"></div>
          <div class="titleA">帮助中心</div>
          <div class="tips" v-if="ifShowNewHelpTips"></div>
        </router-link>

        <router-link to="/Grapher/SignatureList" class="item">
          <div class="menu menu10"></div>
          <div class="titleA">客户签字</div>
        </router-link>
      </div>
    </div>

    <!-- 切换角色 -->
    <van-popup
      v-model="roleTransformShow"
      position="bottom"
      :style="{ height: '30%', width: '100%' }"
    >
      <div class="roleTransform">
        <div class="item li1">切换至</div>
        <div class="item li2" @click="goLshootM">用户中心</div>
        <div class="item li3" @click="goStore">商家版</div>
        <div class="item li4">当前版本 摄影师版</div>
        <div class="item li5" @click="roleTransformShow = false">取消</div>
      </div>
    </van-popup>

    <!-- 系统设置 -->
    <van-popup
      v-model="setConterShow"
      :overlay="false"
      :style="{ height: '100%', width: '100%' }"
    >
      <div class="set-conter">
        <div class="left" @click="setConterShow = false">
          <van-icon name="arrow-left" size="24" />
        </div>
        <div class="titleB">
          <div class="setico"></div>
          系统设置
        </div>
        <div class="list-items">
          <div class="item-li">
            <router-link to="/User/ModifyPwd">
              <div class="left-ic ico2"></div>
              <div class="center-title">修改密码</div>
              <div class="right-ico">
                <van-icon name="arrow" />
              </div>
              <div class="bottom-hr"></div>
            </router-link>
          </div>
          <div class="item-li" @click="logout()">
            <div class="left-ic ico5"></div>
            <div class="center-title">退出登录</div>
            <div class="right-ico">
              <van-icon name="arrow" />
            </div>
          </div>
        </div>
      </div>
    </van-popup>

    <!-- 底部导航 -->
    <van-tabbar v-model="active">
      <van-tabbar-item to="MissionHall">
        <span>任务中心</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_taskCenter.active : icon_taskCenter.inactive
            "
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="Income" icon="chart-trending-o">
        <span>收益</span>
        <template #icon="props">
          <img
            :src="props.active ? icon_earnings.active : icon_earnings.inactive"
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="Order" icon="chart-trending-o">
        <span>我的订单</span>
        <template #icon="props">
          <img :src="props.active ? icon_order.active : icon_order.inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="Center" icon="chart-trending-o">
        <span style="color: #304378">我的</span>
        <template #icon="props">
          <img :src="props.active ? icon_user.active : icon_user.inactive" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import $ from "jquery";
import defaultHead from "@/assets/images/center/head.png";
import { getAllRoles, getCurRole, setRole, setToken } from "@/utils/auth";
import { Icon, Popup, Picker, Toast, Tabbar, TabbarItem } from "vant";
import moment from "moment";
import { getUserByCookie, getIncomeStatistics } from "@/api/m/user";
import { getGrapherInfo } from "@/api/m/grapher";
import { IfHavedHkHelp, getHkHelp } from "@/api/m/store";
import { getUser } from "@/api/m/user";

// 任务中心
import taskCenter_icon from "@/assets/images/center/nav-1.png";
import taskCenter_icon_act from "@/assets/images/center/nav-1-act.png";
//收益
import earnings_icon from "@/assets/images/center/nav-2.png";
import earnings_icon_act from "@/assets/images/center/nav-2-act.png";
//我的订单
import order_icon from "@/assets/images/center/nav-6.png";
import order_icon_act from "@/assets/images/center/nav-6-act.png";
//我的
import user_icon from "@/assets/images/center/nav-7.png";
import user_icon_act from "@/assets/images/center/nav-7-act.png";

export default {
  name: "personal",
  data() {
    return {
      msg: "用户中心",
      pic: "",
      name: "",
      autarkyId: "",
      roleTransformShow: false, //角色切换弹窗
      setConterShow: false, //系统设置
      StaticWebSite: window.StaticWebSite,
      isGrapher: false, //是否含有摄影师角色
      active: 3,
      loading: false,
      finished: false,
      storeData: "",
      defaultHead: defaultHead,
      curRole: "",
      grapherData: null,
      userInfo: {},
      remoteUserInfo: {},
      incomeStatisticsData: null,
      icon_taskCenter: {
        active: taskCenter_icon_act,
        inactive: taskCenter_icon,
      },
      icon_earnings: {
        active: earnings_icon_act,
        inactive: earnings_icon,
      },
      icon_order: {
        active: order_icon_act,
        inactive: order_icon,
      },
      icon_user: {
        active: user_icon_act,
        inactive: user_icon,
      },
      isShowHkHelpButton: false,
      ifShowNewHelpTips: false, //实现显示有新的帮助信息提醒
      imageText: {},
    };
  },
  created() {
    getUserByCookie().then((response) => {
      this.userInfo = response;
    });
    //获取摄影师信息
    this.getGrapherInfo();
    //检查有没有帮助中心信息 
    this.checkHkHelp();
    //获取用户收益统计数据
    //this.getIncomeStatistics();
    //判断有没有最新的帮助信息
    this.checkNewHelp();
  },
  components: {
    "van-popup": Popup,
    "van-icon": Icon,
    "van-picker": Picker,
    "van-tabbar": Tabbar,
    "van-tabbar-item": TabbarItem,
  },
  methods: {
    goLshootM: function () {
      let self = this;
      window.location.href = self.lshootMLink() + "/personal";
    },
    goWatchVideo: function (name) {
      window.location.href = "http://static.lshoot.com/video/" + name + ".mp4";
    },
    goStore: function () {
      let self = this;
      if (self.userInfo.storeId != "") {
        return (window.location.href = "/Store/Other");
      }
      self.tips(
        '<div style="text-align: center;">您还未有店铺，您可以切换至用户中心版进行注册</div>'
      );
    },

    //退出登录
    logout() {
      let self = this;
      //退出登录
      setToken("", moment().add(-1, "days").format("YYYY-MM-DD"));
      window.localStorage.isAutoLogin = "false";
      // 删除cookie
      self.delCookie("lshoot-qupaipai-hkm-account-token");
      self.delCookie("lshoot-qupaipai-hkm-userinfo");
      self.delCookie("lshoot-qupaipai-hkm-account-roles");
      self.delCookie("openid");
      window.location.href = "/user/login";
    },

    //获取摄影师信息
    getGrapherInfo() {
      var selt = this;
      selt.load(true, "加载中...");
      getGrapherInfo()
        .then((response) => {
          selt.load(false);
          const { code, msg, data } = response;
          if (code >= 0) {
            selt.grapherData = data;
            if (selt.grapherData.grapher.photoGrapherName) {
              selt.name = selt.grapherData.grapher.photoGrapherName;
            }
          }
        })
        .catch((response) => {
          this.load(false);
          //this.tips(`${response.msg}`);
          Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
        });
    },

    //获取用户收益统计数据
    getIncomeStatistics() {
      var selt = this;
      const params = {
        IncomeType: 1,
      };
      this.load(true, "加载中...");
      getIncomeStatistics(params)
        .then((response) => {
          this.load(false);
          const { code, msg, data } = response;
          if (code >= 0) {
            this.incomeStatisticsData = data;
            if (selt.storeData.storeFullName) {
              selt.name = selt.storeData.storeFullName;
            }
            if (selt.storeData.logoUrl) {
              selt.pic = selt.storeData.logoUrl;
            }
          }
        })
        .catch((response) => {
          this.load(false);
          //this.tips(`${response.msg}`);
          Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
        });
    },
    checkHkHelp() {  //判断有没有帮助中心的信息，有就显示按钮，没有就隐藏
      IfHavedHkHelp()
        .then(response => {
          const { code, msg, data } = response;
          if (code >= 0) {
            if(data.result===true){
              this.isShowHkHelpButton = true;
            }
          }
        })
        .catch(response => {
          Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
        });
    },
    checkNewHelp() {
				let self = this;
        getUser({userId:self.userInfo.userId})
        .then(response => {
          self.remoteUserInfo = response
          getHkHelp({userId:self.userInfo.userId})
          .then(response => {
            const { code, msg, data } = response;
            if (code >= 0) {
              self.imageText = data;
              if(self.remoteUserInfo.readHelpTime==null || 
              (self.remoteUserInfo.readHelpTime<self.imageText.updateTime))
                self.ifShowNewHelpTips = true;
            }
          })
        })
        .catch(response => {
          Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
        });

			}
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less' scoped>
@import "~@/assets/less/common.less";
@import "~@/assets/less/mixin.less";
.this-box {
  font-size: 0.28rem;
  background: #fff;
  height: 100%;
  .head-bg {
    //background: url(~@/assets/images/center/home-bg2.png) center no-repeat;

    width: 100%;
    background-size: 100% 100%;
    border-bottom: 5px #fafafa solid;
    .right-set-ico {
      background: url(~@/assets/images/center/icon-setting.png) center no-repeat;
      background-size: 100% 100%;
      width: 0.5rem;
      height: 0.5rem;
      float: right;
      margin-right: 0.3rem;
      margin-top: 0.3rem;
    }
    .center-cont {
      height: 1.8rem;
      padding: 0.7rem 0rem 0px 0.5rem;
      display: flex;
      .pic-head {
        width: 1.5rem;
        height: 1.5rem;
        background-color: #fafafa;
        border-radius: 100%;
        overflow: hidden;
        margin: auto 0;
      }
      .left-head-ico {
        width: 1.5rem;
        height: 1.5rem;
        border-radius: 100%;
        float: left;
        margin: auto 0;
      }
      .right {
        float: left;
        height: 2rem;
        padding-left: 0.2rem;
        .user-name {
          //color: #fff;
          font-size: 0.35rem;
          padding-top: 0.6rem;
          max-width: 3.4rem;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          div {
            display: inline-block;
            padding: 0 0.1rem;
          }
        }
        .role {
          color: #2196f3;
          border: 1px #2196f3 solid;
          padding: 3px 5px;
          border-radius: 6px;
          line-height: 0.2rem;
          margin-top: 0.2rem;
          display: inline-block;
          .role-name {
            font-size: 0.2rem;
          }
        }
      }
    }
  }

  .between {
    .head-cont {
      margin: 0 auto;
      height: 0.4rem;
      line-height: 0.4rem;
      padding: 0.1rem 0.3rem;
      .left {
        float: left;
        font-weight: bold;
      }
      .right {
        float: right;
        color: #999;
        font-size: 0.2rem;
        a {
          color: #999;
          display: flex;
          align-items: center;
        }
      }
    }
    .option {
      width: 95%;
      margin: 0 auto;
      padding: 0.2rem 0;
      .item {
        display: inline-block;
        text-align: center;
        width: 24%;
        padding: 0.2rem 0;
        position: relative;
        .bg {
          width: 0.6rem;
          height: 0.6rem;
          margin: 0 auto;
        }
        .titleA {
          padding-top: 0.2rem;
          font-size: 0.2rem;
          color: #333;
        }

        .tips {
          width: 0.14rem;
          height: 0.14rem;
          position: absolute;
          background: red;
          border-radius: 50%;
          top: 0.1rem;
          right: 0.3rem;
        }

        .ico1 {
          background: url(~@/assets/images/center/order-1.png) center no-repeat;
          background-size: 100% 100%;
        }
        .ico2 {
          background: url(~@/assets/images/center/order-2.png) center no-repeat;
          background-size: 100% 100%;
        }
        .ico3 {
          background: url(~@/assets/images/center/order-3.png) center no-repeat;
          background-size: 100% 100%;
        }
        .ico4 {
          background: url(~@/assets/images/center/order-4.png) center no-repeat;
          background-size: 100% 100%;
        }

        .menu {
          width: 0.5rem;
          height: 0.5rem;
          margin: 0 auto;
        }

        .menu1 {
          background: url(~@/assets/images/center/menu-icon-1.png) center
            no-repeat;
          background-size: 100% 100%;
        }
        .menu2 {
          background: url(~@/assets/images/center/menu-icon-2.png) center
            no-repeat;
          background-size: 100% 100%;
        }
        .menu3 {
          background: url(~@/assets/images/center/menu-icon-3.png) center
            no-repeat;
          background-size: 100% 100%;
        }
        .menu4 {
          background: url(~@/assets/images/center/menu-icon-4.png) center
            no-repeat;
          background-size: 100% 100%;
        }
        .menu5 {
          background: url(~@/assets/images/center/menu-icon-5.png) center
            no-repeat;
          background-size: 100% 100%;
        }
        .menu6 {
          background: url(~@/assets/images/center/menu-icon-6.png) center
            no-repeat;
          background-size: 100% 100%;
        }
        .menu7 {
          background: url(~@/assets/images/center/menu-icon-7.png) center
            no-repeat;
          background-size: 100% 100%;
        }
        .menu8 {
          background: url(~@/assets/images/center/menu-icon-8.png) center
            no-repeat;
          background-size: 100% 100%;
        }
        .menu9 {
          background: url(~@/assets/images/center/menu-icon-9.png) center;
          background-size: 100% 100%;
        }
        .menu10 {
          background: url(~@/assets/images/center/menu-icon-10.png) center
            no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }

  .video-box {
    padding: 0.3rem;
    border-top: 5px #fafafa solid;
  }
  .video-lable {
    margin-bottom: 0.2rem;
    border-left: 5px solid #000;
    padding-left: 0.2rem;
    margin-left: 0.5rem;
  }
  .bottom-box {
    margin: 0px auto;
    white-space: nowrap;
    overflow-x: scroll;
    overflow-y: hidden;
    &::-webkit-scrollbar {
      display: none;
    }

    .item {
      width: 3.35rem;
      height: 1rem;
      border-radius: 5px;
      display: inline-block;
      .content {
        background: rgba(0, 0, 0, 0.1);
        height: 1rem;
        border-radius: 10px;
        display: flex;
        color: #fff;
        .titleC {
          font-size: 0.2rem;
          text-align: center;
          line-height: 1rem;
          display: flex;
          align-items: center;
          margin: auto;
        }
      }
    }

    .bg3 {
      background: url(~@/assets/images/center/cover-3.png) center no-repeat;
      background-size: cover;
    }
    .bg4 {
      background: url(~@/assets/images/center/cover-4.png) center no-repeat;
      background-size: cover;
      margin-left: 0.1rem;
    }
  }
}
.roleTransform {
  .item {
    padding-top: 0.48rem;
    text-align: center;
  }
  .li1 {
    color: #000;
    font-size: 0.35rem;
  }
  .li2 {
    color: rgb(238 162 86);
  }
  .li3 {
    color: #374784;
  }
  .li4 {
    font-size: 0.25rem;
    color: #888;
  }
}

.set-conter {
  background: #fafafa;
  height: 100%;
  .left {
    position: absolute;
    left: 0.2rem;
    margin-top: 0.2rem;
    color: #333;
  }
  .titleB {
    text-align: center;
    padding: 0.3rem 0;
    font-size: 0.35rem;
    background-color: #fff;
    color: #333;
  }

  .list-items {
    background: #fff;
    width: 6.5rem;
    margin: 0 auto;
    border-radius: 10px;
    font-size: 0.28rem;
    padding: 0.2rem 0.2rem 0.01rem 0.2rem;
    margin-top: 0.5rem;
    .item-li {
      height: 0.5rem;
      line-height: 0.5rem;
      margin-bottom: 0.3rem;
      a {
        color: #333;
      }

      .left-ic {
        width: 0.3rem;
        height: 0.3rem;
        float: left;
        margin-top: 0.05rem;
      }
      .center-title {
        float: left;
        padding-left: 0.3rem;
      }
      .right-ico {
        float: right;
        i {
          font-weight: bold;
          color: #999;
        }
      }
      .bottom-hr {
        width: 5.8rem;
        border-bottom: 1px solid #999;
        padding-top: 0.6rem;
        margin-left: 0.5rem;
      }
      .ico1 {
        background: url(~@/assets/images/center/icon-9.png) center no-repeat;
        background-size: 100% 100%;
      }
      .ico2 {
        background: url(~@/assets/images/center/icon-5.png) center no-repeat;
        background-size: 100% 100%;
      }
      .ico3 {
        background: url(~@/assets/images/center/icon-7.png) center no-repeat;
        background-size: 100% 100%;
      }
      .ico4 {
        background: url(~@/assets/images/center/icon-12.png) center no-repeat;
        background-size: 100% 100%;
      }
      .ico5 {
        background: url(~@/assets/images/center/icon-10.png) center no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/grapher/center.vue